// フェーズ状態区分
export enum PhaseStatusKinds {
  NotYet = 0,
  Processing = 1, // 処理中
  Done = 2, // 処理済み
}
